module.exports = __webpack_public_path__ + "img/socialmedia.2342ddf3.jpg";